// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --event-info-card-padding-top: 0;
  --event-info-card-padding-bottom: 15px;
  --event-info-card-padding-start: 15px;
  --event-info-card-padding-end: 15px;
  --event-info-card-event-header-image-height: 93px;
  --event-info-card-event-image-size: 76px;
  --event-info-card-event-image-overlap: 46px;
  --event-info-card-background-color: var(--mi-white-color);
}

.event-info-card-container {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: calc(var(--event-info-card-event-header-image-height) - var(--event-info-card-event-image-overlap)), var(--event-info-card-event-image-overlap) calc(var(--event-info-card-event-image-size) - var(--event-info-card-event-image-overlap)) min-content min-content min-content;
  background-color: var(--event-info-card-background-color);
  padding-bottom: var(--event-info-card-padding-bottom);
}
.event-info-card-container .event-header-image-container {
  grid-row: 1/4;
  grid-column: 1;
  width: 100%;
  height: var(--event-info-card-event-header-image-height);
}
.event-info-card-container .event-header-image-container .header-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.event-info-card-container .event-image-container {
  grid-row: 3/5;
  grid-column: 1;
  width: 100%;
  height: 100%;
  padding: 0 var(--event-info-card-padding-end) 0 var(--event-info-card-padding-start);
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: auto min-content;
}
.event-info-card-container .event-image-container app-event-image {
  grid-row: 1;
  grid-column: 1;
  --event-image-size: var(--event-info-card-event-image-size);
  --event-image-border-radius: 12px;
  --event-image-border-width: 3px;
}
.event-info-card-container .title-container {
  grid-row: 5;
  grid-column: 1;
  padding: 15px var(--event-info-card-padding-end) 0 var(--event-info-card-padding-start);
}
.event-info-card-container .title-container .title {
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-large);
  color: var(--mi-secondary-color-2);
  margin: 0;
  cursor: pointer;
}
.event-info-card-container .event-type-container {
  grid-row: 6;
  grid-column: 1;
  padding: 5px var(--event-info-card-padding-end) 0 var(--event-info-card-padding-start);
}
.event-info-card-container .event-type-container .event-type {
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-regular);
  color: var(--mi-color-text-lite);
  margin: 0;
}
.event-info-card-container .participants-container {
  grid-row: 7;
  grid-column: 1;
  padding: 15px var(--event-info-card-padding-end) 0 var(--event-info-card-padding-start);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
